module.exports = __webpack_public_path__ + "assets/images/CAD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CAD20.png
// module id = 1328
// module chunks = 1